import { LaserfichePushHistoryForm } from "./LaserfichePushHistoryForm";

export interface LaserfichePushHistoryEditorProps {
  tenantId: string;
}

export const LaserfichePushHistoryEditor = ({
  tenantId,
}: LaserfichePushHistoryEditorProps) => {
  return (
    <div className="flex flex-col gap-4">
      <p>
        If you have been using CiviDocs for some time, and have existing
        meetings that were published before the Laserfiche connection was
        established, use the form below to send those meetings to Laserfiche.
      </p>
      <p>
        Sending a meeting to Laserfiche will send the agenda, any attached
        documents, and the meeting's official minutes, according to the
        configuration provided, depending on which team the meeting is in.
      </p>

      <LaserfichePushHistoryForm tenantId={tenantId} />
    </div>
  );
};
